import { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, InputAdornment } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useCimbeo } from '../../../../context';

function ProjectSelector({ onProjectSelect, initialValue = '' }) {
  const { projects: defaultProjects } = useCimbeo();
  const [selectedProject, setSelectedProject] = useState(initialValue);

  const projects = defaultProjects;

  useEffect(() => {
    if (initialValue) {
      setSelectedProject(initialValue);
    }
  }, [initialValue]);

  const handleChange = (event) => {
    setSelectedProject(event.target.value);
    onProjectSelect(event.target.value);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 900, mb: 3 }}>
      <FormControl fullWidth>
        <InputLabel 
          sx={{ 
            color: 'text.main',
            '&.Mui-focused': {
              color: 'text.main',
            },
          }}
          id="project-select-label"
        >
          Select Project
        </InputLabel>
        <Select
          labelId="project-select-label"
          value={selectedProject}
          label="Select Project"
          onChange={handleChange}
          required
          endAdornment={
            <InputAdornment position="end" sx={{ mr: 1 }}>
              <Box sx={{ transform: 'scale(1.5)', color: 'text.main' }}>
                <ExpandMoreIcon />
              </Box>
            </InputAdornment>
          }
          sx={{
            height: 50,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'text.main',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'text.main',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'text.main',
            },
            backgroundColor: 'slate_gray.main',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            '& .MuiSelect-select': {
              color: 'white',
              fontWeight: 500,
              padding: '16.5px 14px',
            },
          }}
        >
          {projects.map((project) => (
            <MenuItem 
              key={project.title} 
              value={project.title}
              sx={{
                height: 48,
                backgroundColor: 'slate_gray.main',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'slate_gray.focus',
                },
                '&.Mui-selected': {
                  backgroundColor: 'slate_gray.focus',
                  '&:hover': {
                    backgroundColor: 'slate_gray.focus',
                  },
                },
              }}
            >
              {project.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default ProjectSelector; 